import { GroupUserRole } from 'multirpc-sdk';

export const DEFAULT_TEAM_MEMBERS_LIMIT = 20;

export const teamRoleNamesMap: Record<GroupUserRole, string> = {
  [GroupUserRole.admin]: 'teams.roles.admin',
  [GroupUserRole.dev]: 'teams.roles.dev',
  [GroupUserRole.finance]: 'teams.roles.finance',
  [GroupUserRole.owner]: 'teams.roles.owner',
};

export const SUCCESS_TEAM_CREATION_NOTIFICATION_ID =
  'SUCCESS_TEAM_CREATION_NOTIFICATION_ID';
export const AVOID_CLOSING_NEW_TEAM_NOTIFICATION_FLAG =
  'AVOID_CLOSING_NEW_TEAM_NOTIFICATION_FLAG';
